import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useAccountsStore = create(
  persist(
    (set) => ({
  accounts: [
    { id: 1, name: 'Twitter @Company', type: 'social_media', service: 'Twitter', username: '@company', status: 'Connected', lastSync: '2 hours ago' },
    { id: 2, name: 'LinkedIn Company Page', type: 'social_media', service: 'LinkedIn', username: 'company-page', status: 'Connected', lastSync: '1 hour ago' },
    { id: 3, name: 'Gmail Support', type: 'email', service: 'Gmail', username: 'support@company.com', status: 'Connected', lastSync: '5 min ago' },
    { id: 4, name: 'Facebook Page', type: 'social_media', service: 'Facebook', username: 'company', status: 'Connected', lastSync: '30 min ago' },
    { id: 5, name: 'Instagram Business', type: 'social_media', service: 'Instagram', username: '@company_official', status: 'Connected', lastSync: '1 hour ago' },
    { id: 6, name: 'Stripe Payment', type: 'payment', service: 'Stripe', username: 'sk_live_xxxx', status: 'Connected', lastSync: '30 min ago' },
  ],

  // Add account
  addAccount: (accountData) =>
    set((state) => ({
      accounts: [...state.accounts, { id: Date.now(), ...accountData }],
    })),

  // Update account
  updateAccount: (id, updatedData) =>
    set((state) => ({
      accounts: state.accounts.map((account) =>
        account.id === id ? { ...account, ...updatedData } : account
      ),
    })),

  // Delete account
  deleteAccount: (id) =>
    set((state) => ({
      accounts: state.accounts.filter((account) => account.id !== id),
    })),

  // Get accounts by type
  getAccountsByType: (type) => {
    const state = useAccountsStore.getState()
    return state.accounts.filter((account) => account.type === type)
  },

  // Get accounts by service
  getAccountsByService: (service) => {
    const state = useAccountsStore.getState()
    return state.accounts.filter((account) => account.service === service)
  },

  // Get single account by ID
  getAccountById: (id) => {
    const state = useAccountsStore.getState()
    return state.accounts.find((account) => account.id === id)
  },

  // Get all accounts
  getAllAccounts: () => useAccountsStore.getState().accounts,
    }),
    {
      name: 'accounts-storage',
    }
  )
)
